import { handleAction, combineActions } from 'redux-actions';
import {
  receiveAuth,
  receiveLogout,
  updateUserPending,
  updateUserSucess,
  updateUserError,
  receiveUser
} from './actions';

// eslint-disable-next-line
export const user = handleAction(
  combineActions(
    receiveAuth,
    receiveLogout,
    updateUserPending,
    updateUserSucess,
    updateUserError
  ),
  {
    next(state, action) {
      return action.payload;
    }
  },
  {}
);

export const getUser = handleAction(
  receiveUser,
  {
    next(state, { payload }) {
      return payload;
    }
  },
  []
);



// WEBPACK FOOTER //
// ./src/modules/user/reducers.js